import { Autoplay, Swiper } from 'swiper';

class ReviewSwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Autoplay],
      allowTouchMove: false,
      slidesPerView: 'auto',
      spaceBetween: 80,
      speed: 14000,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        992: {
          speed: 24000,
        },
      },
    })
  }
}

export default ReviewSwiper;
